import {FieldDuration, FieldTime, FormSection} from "../../../ui";
import {ShipmentReadyConfigurationDto, ShipmentTypeDto} from "../../../../api/cms";
import {displayShipmentType} from "../../../../api";
import {useEffect, useState} from "react";
import {durationToIso8601String, parseIso8601StringToDuration, parseStringToTime} from "../../../../utils";

interface CmsShipmentReadyConfigurationFormProps {
    value: ShipmentReadyConfigurationDto[]
    onChange: (value: ShipmentReadyConfigurationDto[]) => any
    validate: () => Promise<any>
    saving: boolean
}

interface RowData {
    type: ShipmentTypeDto
    limes?: string;
    waitBeforeReady?: string;
}

interface RowProps {
    saving: boolean
    value: RowData
    onBlur: () => Promise<any>
    onChange: (value: RowData) => any
}

function ReadyRow({
                      onBlur,
                      onChange,
                      value,
                      saving
                  }: RowProps) {

    return <div className={"columns"}>
        <div className={"column is-one-third"} style={{fontWeight: 'bold'}}>{displayShipmentType(value.type)}</div>
        <div className={"column is-one-third"}>
            <FieldTime
                value={parseStringToTime(value.limes)}
                label={"bereit ab"}
                required={true}
                disabled={saving}
                onBlur={onBlur}
                onChange={v => {
                    const timeVal = `${v.hours.toString().padStart(2, '0')}:${v.minutes.toString().padStart(2, '0')}:00`
                    onChange({
                        ...value,
                        limes: timeVal
                    })
                }}
            />
        </div>
        <div className={"column is-one-third"}>
            <FieldDuration
                label={`Wartezeit`}
                required={false}
                disabled={saving || !value.limes}
                value={value.waitBeforeReady ? parseIso8601StringToDuration(value.waitBeforeReady) : undefined}
                onBlur={onBlur}
                onChange={(v) => {
                    onChange({
                        ...value,
                        waitBeforeReady: v ? durationToIso8601String(v) : undefined
                    })
                }}
            />
        </div>
    </div>
}

const CmsShipmentReadyConfigurationForm = function CmsShipmentReadyConfigurationForm({
                                                                                         value,
                                                                                         saving,
                                                                                         onChange,
                                                                                         validate
                                                                                     }: CmsShipmentReadyConfigurationFormProps) {
    const [values, setValues] = useState(new Map<ShipmentTypeDto, RowData>())

    useEffect(() => {
        const mapped = value.reduce((c, v) => {
            c.set(v.shipmentType, {
                type: v.shipmentType,
                limes: v.limes,
                waitBeforeReady: v.waitBeforeReady
            })
            return c
        }, new Map<ShipmentTypeDto, RowData>())
        setValues(mapped)
    }, [
        value
    ])


    return <FormSection
        label={"Versandabschlusszeit"}>
        <>
            {Object.keys(ShipmentTypeDto).map(e => e as ShipmentTypeDto).map(type => {
                return <ReadyRow
                    key={type}
                    saving={saving}
                    value={values.get(type) || {
                        type,
                        limes: '',
                        waitBeforeReady: ''
                    }}
                    onBlur={async () => {
                        await validate()
                    }}
                    onChange={(val) => {
                        values.set(val.type, val)
                        const out = Array.from(values.values())
                            .filter(r => r.limes)
                            .map(e => ({
                                shipmentType: e.type,
                                limes: e.limes || '',
                                waitBeforeReady: e.waitBeforeReady
                            }))
                        onChange(out)
                    }}
                />
            })}
        </>
    </FormSection>
}

export {
    CmsShipmentReadyConfigurationForm
}
